let _initProto, _initClass;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
function _identity(t) { return t; }
import { Server, enable } from "appserver";
import { ApplicationServer } from "appserver";
import { HttpServer, http } from "appserver";
import { ApplicationConsole } from "appserver";
import { HAProxyIntegration } from "appserver";
import { SystemdIntegration } from "appserver";
import { AuthenticationService, auth } from "appserver";

//import MyAuthPlugin				   		from "./plugins/plugin-myauth.js";

import SDBus from "sd-bus";
const PATH = "/home/pi/fermentations";
const LOGPATH = "/home/pi/logs/logs.json";
var settings = {};

/* Thermostat PID parameters */
const Kp = 15;
const Ki = 0.005;
const Kd = 15;

/* Dissolved Oxygen PID parameters */
const DO_Kp = 0;
const DO_Ki = 0.1;
const DO_Kd = 1;

/* PH PID parameters */
const PH_Kp = 100;
const PH_Ki = 0;
const PH_Kd = 0;
import config from "config";
import moment from "moment";
import Serial from "serial";
import { SerialPort } from "webserial";
import I2C from "i2c";
import Modbus from "./peripherals/modbus_with_scheduler.js";
import globalSettings from "./inc/settings.js";
import * as fs from "fs";
import sleep from "sleep";

/* emulated USB devices */
import LEDs from "./peripherals/leds/index.js";
import Thermostat from "./peripherals/thermostat/index.js";
import JMC_MCAC708 from "./peripherals/jmc_mcac708/index.js";

/* USB connected webserial devices */
import WebSerial from "webserial";
import EZO_RGB from "./peripherals/ezo_rgb/index.js";
import EZO_CO2 from "./peripherals/ezo_co2/index.js";
import EZO_O2 from "./peripherals/ezo_o2/index.js";
import EZO_PMP from "./peripherals/ezo_pmp/index.js";
import Illumination from "./peripherals/illumination/index.js";
import GSS_CO2 from "./peripherals/gss_co2/index.js";
import MX200_O2 from "./peripherals/mx200_o2/index.js";
import MX200_CO2 from "./peripherals/mx200_co2/index.js";
import IQFlow from "./peripherals/bronkhorst_iqflow/index.js";
import Visiferm_DO from "./peripherals/visiferm_do/index.js";
import Visiferm_PH from "./peripherals/visiferm_ph/index.js";
import Hamilton_Dencytee from "./peripherals/hamilton_dencytee/index.js";
import Thermostat2l from "./peripherals/thermostat2l/index.js";
import Valve_2i1o from "./peripherals/valve_2i1o/index.js";
import Valve_1i2o from "./peripherals/valve_1i2o/index.js";

/* USB connected video devices*/
import WebCam from "./peripherals/webcam/index.js";

/* i2c devices */
import EZO_DO from "./peripherals/ezo_do/index.js";
import EZO_RTD from "./peripherals/ezo_rtd/index.js";
import EZO_PH from "./peripherals/ezo_ph/index.js";
import EZO_EC from "./peripherals/ezo_ec/index.js";
import Parallax_Pump from "./peripherals/parallax_pump/index.js";

//TODO: remove when possible
//import UPS				from "./peripherals/upspico/index.js";

/* Services */
import FermentationService from "./services/service-fermentation.js";
import JournalService from "./services/service-journal.js";
import JSONLogService from "./services/service-log-json.js";
import EmailService from "./services/service-email.js";
import ClientUpdaterService from "./services/service-updateclients.js";
import LimitsService from "./services/service-limits.js";
import VersionInfoService from "./services/service-versioninfo.js";
import UpdateService from "./services/service-update.js";
import UptimeService from "./services/service-uptime.js";
import UserScriptService from "./services/service-userscript.js";
import USBUtilService from "./services/service-usbutil.js";
const devicesByName = {
  "Off-Gas CO2 Sensor": GSS_CO2,
  /* old device name */
  "Off-Gas O2 Sensor": MX200_O2,
  /* old device name */
  "gss co2": GSS_CO2,
  "mx200 o2": MX200_O2,
  "mx300 o2": MX200_O2,
  /* mx300 board is compatible with mx200 */
  "mx300 co2": MX200_CO2,
  "IQFlow MFC": IQFlow,
  "bronkhorst_iqflow": IQFlow,
  "Illumination module": Illumination,
  "RGB Sensor": EZO_RGB,
  "EZO CO2": EZO_CO2,
  "EZO O2": EZO_O2,
  "EZO PMP": EZO_PMP,
  "Visiferm DO": Visiferm_DO,
  "Visiferm PH": Visiferm_PH,
  "hamilton_dencytee": Hamilton_Dencytee,
  "thermostat2l": Thermostat2l,
  "valve_2i1o": Valve_2i1o,
  "valve_1i2o": Valve_1i2o
};

/*
  Events emitted by MyServer
  fermentationstart: fermentation started
  fermentationend: fermentation finished successfily after the defined period (not fired if it is stopped by the user)
  fermentationstop: whenever a fermentation is stopped for any reason
  update: fires every 3 seconds, dispatches the current state of every device
  TODO: updatedevice: fires every 3 seconds, each device have to catch this event, and update its status and store its status in memory for later use
  TODO: logdevice: fires every 3 seconds, after updatedevice event. each device have to catch this event and append its values that should be logged 
  TODO: updateclients
  TODO: control

  stop: if stop event is emitted it will stop the current fermentation if any, and will put all devices into idle state (e.g. stop heating, stop pumps)
*/

/*
  The order of the services are important.
  services will be started in this order.

  If a service that is used by an other service is not fully started
  that will cause a problem

  For example: FermentationService will fire onfermentationstart events in its constructor
  so every service that are waiting for this event must be started before this service    
*/

//@enable( JournalService ) TODO: move to different microservice, confuses Worker class ? WTF, or freeze event loop
//@enable( EmailService )
let _MyServer;
new class extends _identity {
  static [class MyServer extends Server {
    static {
      ({
        e: [_initProto],
        c: [_MyServer, _initClass]
      } = _applyDecs(this, [enable(JSONLogService), enable(ClientUpdaterService), enable(UptimeService), enable(UserScriptService), enable(FermentationService), enable(ApplicationConsole), enable(HAProxyIntegration, [{
        port: 8083,
        endpoint: /^\/api\/pc(?:\/.*)?$/,
        slot: "http_slot03"
      }, {
        port: 8000,
        endpoint: /^\/server\.jss$/,
        slot: "ws_slot00"
      }]), enable(SystemdIntegration), enable(HttpServer, {
        port: 8083,
        backlog: 128
      }), enable(AuthenticationService), enable(ApplicationServer)], [[[http.get('/api/pc/parameters'), auth.validate()], 2, "getParameters"], [[http.post('/api/pc/parameters'), auth.validate()], 2, "setParameters"], [[http.get('/api/pc/poweroff'), auth.validate()], 2, "poweroff"]], 0, void 0, Server));
    }
    constructor() {
      _initProto(super());

      //this.start();

      /* put server into global namespace so that peripherials could listen for server events */
      /* server.addeventlistener ...                                                          */
      global.jfermi = this;

      //this.loginRequired = false;

      /* create basic settings */
      if (!localStorage.getItem("settings")) {
        localStorage.setItem("settings", JSON.stringify({
          T_Kp: Kp,
          T_Ki: Ki,
          T_Kd: Kd,
          DO_Kp: DO_Kp,
          DO_Ki: DO_Ki,
          DO_Kd: DO_Kd,
          PH_Kp: PH_Kp,
          PH_Ki: PH_Ki,
          PH_Kd: PH_Kd,
          Stirring_MAX_RPM: 1200,
          Stirring_MIN_RPM: 300
        }));
      }
      settings = JSON.parse(localStorage.getItem("settings"));
      settings.IQFlow_on_ttyAMA0 ??= 0;
      settings.IQFlow_MIN_MLM ??= 300;
      settings.IQFlow_MAX_MLM ??= 500;
      settings.VisifermDO_on_ttyAMA0 ??= 0;
      settings.VisifermPH_on_ttyAMA0 ??= 0;
      settings.AcidPump_MIN_MLH ??= 0;
      settings.AcidPump_MAX_MLH ??= 20;
      settings.BasePump_MIN_MLH ??= 0;
      settings.BasePump_MAX_MLH ??= 20;
      settings.DO2_Kp ??= 1;
      settings.DO2_Ki ??= 0.1;
      settings.DO2_Kd ??= 1;
      if (settings.hasOwnProperty("device_qups")) delete settings["device_qups"];
      if (settings.hasOwnProperty("PH_analog")) delete settings["PH_analog"];
      if (settings.hasOwnProperty("DO_analog")) delete settings["DO_analog"];
      if (settings.hasOwnProperty("Airflow_disable")) delete settings["Airflow_disable"];
      if (settings.hasOwnProperty("VisiferPH_on_ttyAMA0")) delete settings["VisiferPH_on_ttyAMA0"];
      localStorage.setItem("settings", JSON.stringify(settings));
      this.i = 0;
      this.shuttingdown = false;
      this.shutdownwait = 3;
    }
    async start(...args) {
      await super.start(...args);

      /* initialize devices in this.devices object */
      this.initialize_devices_static();

      /* wait a sec becuse USB devices are put into this.devices object                     */
      /* so this.initialize_devices(); would init them again                                */
      /* goal is to remove all static devices, each of them should dynamically initialized  */
      setTimeout(function () {
        this.initialize_devices_webserial();
        this.initialize_devices_i2c();
        this.initialize_devices_webcam();
      }.bind(this), 1000);
      WebSerial.addEventListener("connect", this.serial_connect_handler.bind(this));
      WebSerial.addEventListener("disconnect", this.serial_disconnect_handler.bind(this));
      console.log("biocore started.");
    }
    async stop(...args) {
      await super.stop(...args);
      console.log("biocore stopped.");
    }
    async serial_connect_handler(event) {
      var serialPort = event.target;
      var usbProductName = (await serialPort.getInfo()).usbProductName;
      var usbSerialNumber = (await serialPort.getInfo()).usbSerialNumber;
      console.log(`Device connected: usbProductName: ${usbProductName}, usbSerialNumber: ${usbSerialNumber}`);
      if (!(usbProductName in devicesByName)) return;
      var device = new devicesByName[usbProductName](serialPort);
      await device.initialize();

      /* first we have to initialize the device   */
      /* initialize method sets its name property */
      serialPort.name = device.name; //save name for later disconnection
      this.devices[device.name] = device;
      console.log(`Device initialized: usbProductName: ${usbProductName}, usbSerialNumber: ${usbSerialNumber}, Name: ${device.name}`);
    }
    async serial_disconnect_handler(event) {
      var serialPort = event.target;
      var usbProductName = (await serialPort.getInfo()).usbProductName;
      var usbSerialNumber = (await serialPort.getInfo()).usbSerialNumber;
      if (typeof this.devices[serialPort.name].disconnect == "function") this.devices[serialPort.name].disconnect(serialPort);
      delete this.devices[serialPort.name];
      console.log(`Device disconnected: usbProductName: ${usbProductName}, usbSerialNumber: ${usbSerialNumber}, Name: ${serialPort.name}`);
    }
    async initialize_devices_webserial() {
      var ports = await WebSerial.getPorts();
      for (const port of ports) {
        try {
          await this.serial_connect_handler({
            //do not await here, because in case of error the itialalization of other device will be stopped
            target: port
          });
        } catch (e) {
          console.error(`failed to initialze: ${e.message}`);
        }
      }
    }
    async initialize_devices_webcam() {
      if (fs.existsSync("/dev/video0")) {
        /* this is just a stub, this is a completly separate systemd service */
        this.devices.webcam = new WebCam("/dev/video0");
      }
    }
    async initialize_devices_i2c() {
      var ezodoSensor = new EZO_DO();
      try {
        await ezodoSensor.initialize();
        this.devices.ezodoSensor = ezodoSensor;
        console.log(`found ezo do sensors at i2c address ${0x61}`);
      } catch (e) {}
      var ezortdSensor = new EZO_RTD();
      try {
        await ezortdSensor.initialize();
        this.devices.ezortdSensor = ezortdSensor;
        console.log(`found ezo rtd sensors at i2c address ${0x66}`);
      } catch (e) {}
      var ezophSensor = new EZO_PH();
      try {
        await ezophSensor.initialize();
        this.devices.ezophSensor = ezophSensor;
        console.log(`found ezo ph sensors at i2c address ${0x63}`);
      } catch (e) {}
      try {
        let ezoecSensor = new EZO_EC();
        await ezoecSensor.initialize();
        this.devices.ezoecSensor = ezoecSensor;
        console.log(`found ezo ec sensors at i2c address ${0x64}`);
      } catch (e) {}
      try {
        var i2cBus = new I2C();
        await i2cBus.open("/dev/i2c-1", 0x10);
        let parallaxPumpAcid = new Parallax_Pump(i2cBus, "parallax_pump", "3");
        let parallaxPumpBase = new Parallax_Pump(i2cBus, "parallax_pump", "2");
        let parallaxPumpFeed = new Parallax_Pump(i2cBus, "parallax_pump", "4");
        let parallaxPumpAntifoam = new Parallax_Pump(i2cBus, "parallax_pump", "1");
        await parallaxPumpAcid.initialize();
        await parallaxPumpBase.initialize();
        await parallaxPumpFeed.initialize();
        await parallaxPumpAntifoam.initialize();
        this.devices.parallaxPumpAcid = parallaxPumpAcid;
        this.devices.parallaxPumpBase = parallaxPumpBase;
        this.devices.parallaxPumpFeed = parallaxPumpFeed;
        this.devices.parallaxPumpAntifoam = parallaxPumpAntifoam;
        console.log(`found 4 parallax pumps at i2c address 0x10`);
      } catch (e) {}
      try {
        var thermostat = new Thermostat();
        await thermostat.initialize();
        this.devices.thermostat = thermostat;
        console.log(`found thermostat at i2c address 0x40`);
      } catch (e) {}
    }
    async initialize_devices_static() {
      this.devices = {};
      try {
        let leds = new LEDs();
        await leds.initialize();
        this.devices.leds = leds;
        this.devices.leds.green = 1;
        console.log(`found leds`);
      } catch (e) {}
      try {
        let stirring = new JMC_MCAC708();
        await stirring.initialize();
        this.devices.stirring = stirring;
        console.log(`found JMC_MCAC708`);
      } catch (e) {}
      var serialPort = new SerialPort();
      /* wrap the serialPort object into Modbus */
      var modbus = new Modbus();
      modbus.wrap(serialPort);
      await modbus.open({
        path: "/dev/ttyAMA0",
        baudRate: 19200,
        dataBits: 8,
        parity: "none",
        stopBits: 2
      });
      if (settings["IQFlow_on_ttyAMA0"]) {
        try {
          let iqflow = new IQFlow(modbus);
          await iqflow.initialize();
          this.devices.iqflow = iqflow;
          console.log(`found IQFlow_on_ttyAMA0`);
        } catch (e) {
          console.error(e.message);
        }
      }
      if (settings["VisifermDO_on_ttyAMA0"]) {
        try {
          let visifermdo = new Visiferm_DO(modbus);
          await visifermdo.initialize();
          this.devices.visifermdo = visifermdo;
          console.log(`found VisifermDO_on_ttyAMA0`);
        } catch (e) {
          console.error(e.message);
        }
      }
      if (settings["VisifermPH_on_ttyAMA0"]) {
        try {
          let visifermph = new Visiferm_PH(modbus);
          await visifermph.initialize();
          this.devices.visifermph = visifermph;
          console.log(`found VisifermPH_on_ttyAMA0`);
        } catch (e) {
          console.error(e.message);
        }
      }
    }
    RM_auth_login(request, username, password) {
      var ret = super.RM_auth_login(request, username, password);
      console.log(`${username}: logged in`);
      return ret;
    }
    onclose(client) {
      console.log(`${client.username}: logged out`);
    }
    RM_log_list(request, from, to) {
      var arrayBuffer = fs.readFileSync(LOGPATH);
      var str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
      var values = JSON.parse(`[${str.replace(/\n/g, ",\n")}{}]`);
      return values;
      from = new Date(from);
      to = new Date(to);
      values = values.filter(function (value) {
        var dt = new Date(value.dt);
        return from <= dt && dt <= to;
      });
      return values;
    }
    async getParameters(request) {
      let settings = JSON.parse(localStorage.getItem("settings"));
      return new Response(JSON.stringify(settings), {
        status: 200,
        headers: {
          "Content-Type": "text/plain",
          "Cache-Control": "no-store"
        }
      });
    }
    async setParameters(request) {
      const newSettings = await request.json();
      for (var name in newSettings) {
        if (isNaN(newSettings[name])) {
          return new Response(`Invalid value: ${newSettings[name]}`, {
            status: 400,
            headers: {
              'Content-Type': 'text/plain',
              'Cache-Control': 'no-store'
            }
          });
        }
      }
      localStorage.setItem("settings", JSON.stringify(newSettings));

      /*TODO: remove this global variable, its ugly*/
      settings = newSettings;
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain",
          "Cache-Control": "no-store"
        }
      });
    }
    onpower_handler() {
      console.log(`system: Power restored. Shutdown cancelled.`);
    }
    onbattery_handler() {
      console.log(`system: Power loss. Wait 10 sec before shutdown.`);
    }
    async poweroff(request) {
      let sdbus = new SDBus();
      await sdbus.open_system();
      let CanPowerOff = await sdbus.call_method("org.freedesktop.login1", "/org/freedesktop/login1", "org.freedesktop.login1.Manager", "CanPowerOff");
      await sdbus.close();
      if (CanPowerOff[0] != "yes") {
        console.warn(`system: Shutdown init failed!`);
        return new Response("Forbidden", {
          status: 403,
          headers: {
            "Content-Type": "text/plain",
            "Cache-Control": "no-store"
          }
        });
      }
      this.devices.leds.green = 0;
      this.finishCurrentFermentation();
      setTimeout(async function _(sec) {
        let sdbus = new SDBus();
        await sdbus.open_system();

        // PowerOff(boolean interactive)
        // false = do not ask for confirmation
        await sdbus.call_method("org.freedesktop.login1", "/org/freedesktop/login1", "org.freedesktop.login1.Manager", "PowerOff", false);
        await sdbus.close();
      }.bind(this), 10 * 1000);
      console.log(`system: Shutdown initiated! System is going down for halt in 10 seconds`);
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain",
          "Cache-Control": "no-store"
        }
      });
    }
    log(username, type, message) {
      console.log(message);
    }
  }];
  constructor() {
    super(_MyServer), (() => {
      new this();
    })(), _initClass();
  }
}();